module.exports = __webpack_public_path__ + "static/media/main-weapon.c4ba88cb.png";